<div class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-5">
      <div class="card shadow-lg border-0 reset-password-card">
        <div class="card-body p-5">
          <!-- Icon -->
          <div class="icon-wrapper text-center mb-4">
            <div class="reset-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
              </svg>
            </div>
          </div>

          <!-- Titre et description -->
          <h2 class="text-center fw-bold mb-3">Réinitialiser le mot de passe</h2>
          <p class="text-center text-muted mb-4">
            Choisissez un nouveau mot de passe sécurisé pour votre compte.
          </p>

          <!-- Formulaire -->
          <form #resetPasswordForm="ngForm" (ngSubmit)="onSubmit()">
            
            <!-- Nouveau mot de passe -->
            <div class="mb-3">
              <label for="password" class="form-label fw-semibold">Nouveau mot de passe</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                </span>
                <input 
                  [type]="showPassword ? 'text' : 'password'" 
                  class="form-control border-start-0 border-end-0 ps-0" 
                  id="password" 
                  name="password"
                  [(ngModel)]="password"
                  placeholder="••••••••"
                  required
                  minlength="8"
                  #passwordInput="ngModel">
                <button 
                  class="btn btn-outline-secondary border-start-0" 
                  type="button"
                  (click)="showPassword = !showPassword">
                  <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                </button>
              </div>
              <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)" class="text-danger small mt-1">
                <div *ngIf="passwordInput.errors?.['required']">Le mot de passe est requis</div>
                <div *ngIf="passwordInput.errors?.['minlength']">Le mot de passe doit contenir au moins 8 caractères</div>
              </div>
            </div>

            <!-- Force du mot de passe -->
            <div class="mb-3" *ngIf="password">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <small class="text-muted">Force du mot de passe</small>
                <small [ngClass]="getPasswordStrengthClass()">{{getPasswordStrengthText()}}</small>
              </div>
              <div class="progress" style="height: 6px;">
                <div 
                  class="progress-bar transition" 
                  [ngClass]="getPasswordStrengthClass()"
                  [style.width]="getPasswordStrengthWidth()"
                  role="progressbar">
                </div>
              </div>
            </div>

            <!-- Confirmation mot de passe -->
            <div class="mb-4">
              <label for="confirmPassword" class="form-label fw-semibold">Confirmer le mot de passe</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                </span>
                <input 
                  [type]="showConfirmPassword ? 'text' : 'password'" 
                  class="form-control border-start-0 border-end-0 ps-0" 
                  id="confirmPassword" 
                  name="confirmPassword"
                  [(ngModel)]="confirmPassword"
                  placeholder="••••••••"
                  required
                  #confirmPasswordInput="ngModel">
                <button 
                  class="btn btn-outline-secondary border-start-0" 
                  type="button"
                  (click)="showConfirmPassword = !showConfirmPassword">
                  <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                </button>
              </div>
              <div *ngIf="confirmPasswordInput.touched && password !== confirmPassword" class="text-danger small mt-1">
                Les mots de passe ne correspondent pas
              </div>
            </div>

            <!-- Exigences du mot de passe -->
            <div class="alert alert-light border mb-4">
              <small class="fw-bold d-block mb-2">Le mot de passe doit contenir :</small>
              <small class="d-block mb-1" [ngClass]="password.length >= 8 ? 'text-success' : 'text-muted'">
                <span *ngIf="password.length >= 8">✓</span>
                <span *ngIf="password.length < 8">○</span>
                Au moins 8 caractères
              </small>
              <small class="d-block mb-1" [ngClass]="hasUpperCase(password) ? 'text-success' : 'text-muted'">
                <span *ngIf="hasUpperCase(password)">✓</span>
                <span *ngIf="!hasUpperCase(password)">○</span>
                Une lettre majuscule
              </small>
              <small class="d-block mb-1" [ngClass]="hasLowerCase(password) ? 'text-success' : 'text-muted'">
                <span *ngIf="hasLowerCase(password)">✓</span>
                <span *ngIf="!hasLowerCase(password)">○</span>
                Une lettre minuscule
              </small>
              <small class="d-block" [ngClass]="hasNumber(password) ? 'text-success' : 'text-muted'">
                <span *ngIf="hasNumber(password)">✓</span>
                <span *ngIf="!hasNumber(password)">○</span>
                Un chiffre
              </small>
            </div>

            <!-- Message d'erreur -->
            <div *ngIf="error" class="alert alert-danger d-flex align-items-center mb-4" role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <div>{{error}}</div>
            </div>

            <!-- Bouton submit -->
            <div class="d-grid mb-4">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg"
                [disabled]="resetPasswordForm.invalid || password !== confirmPassword || isLoading">
                <span *ngIf="!isLoading">Réinitialiser le mot de passe</span>
                <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Réinitialisation...
                </span>
              </button>
            </div>

            <!-- Lien retour -->
            <div class="text-center">
              <a routerLink="/signin" class="text-decoration-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-1">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Retour à la connexion
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>